import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DisplayTextConfig } from '@access-request-unicorn/models/display-text-config.model';
import { ConfigFacade } from '@access-request-unicorn/services/config.facade';

@Component({
  selector: 'access-request-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  textConfig$!: Observable<DisplayTextConfig>;

  constructor(private config: ConfigFacade) {}

  ngOnInit() {
    this.textConfig$ = this.config.displayText$;
  }

}
